import React, { useMemo } from "react";
import moment from "moment";
import TableContainer from "./TableContainer";
import PatientLoader from "../../../common/PatientLoader";
import "./OverdueInvoicesDataTableStyles.css";
import { useNavigate } from "react-router-dom";

const OverdueInvoicesDataTable = ({ loading, data }) => {
  const navigate = useNavigate();
  const getOpenInvoices = (invoicingHistory) => {
    if (invoicingHistory.length === 0) return 0;
    let temp = [];
    temp = invoicingHistory.filter((item) => item?.status === "OPEN");
    return parseInt(temp.length);
  };
  //
  let renderColumns = [
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>{cell.value}</span>
        );
      },
    },
    {
      Header: "Created",
      accessor: "created",
      sortType: (a, b) => {
        if (a === null || a === undefined || a === "" || a === "Not Available")
          return 1; // place null values at the bottom
        if (b === null || b === undefined || b === "" || b === "Not Available")
          return -1;
        return new Date(b?.values?.created) - new Date(a?.values?.created);
      },

      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value
              ? moment(cell.value).format("MMM Do, YYYY")
              : "Not Available"}
          </span>
        );
      },
    },
    {
      Header: "Sales Representative",
      accessor: "rose_sales_team_member",
      Cell: ({ cell }) => {
        return (
          <span style={{ textTransform: "capitalize" }}>
            {cell.value || "Not Specified"}
          </span>
        );
      },
    },
    {
      Header: "Invoices 30 Days Ovedue",
      accessor: "invoicing_history",
      disableSortBy: true,
      Cell: ({ cell }) => {
        let pendingInvoices = 0;
        pendingInvoices = cell.value?.length > 0 && getOpenInvoices(cell.value);
        if (pendingInvoices === false) {
          pendingInvoices = 0;
        }
        return (
          <span style={{ color: pendingInvoices > 0 ? "red" : "green" }}>
            {pendingInvoices}
          </span>
        );
      },
    },
    {
      Header: "Invoices 60 Days Ovedue",
      accessor: (d) => d.invoicing_history,
      disableSortBy: true,
      Cell: ({ cell }) => {
        let pendingInvoices = 0;
        pendingInvoices = cell.value?.length > 0 && getOpenInvoices(cell.value);
        if (pendingInvoices === false) {
          pendingInvoices = 0;
        }
        return (
          <span style={{ color: pendingInvoices > 0 ? "red" : "green" }}>
            {pendingInvoices}
          </span>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <button
            onClick={() => navigate(`/ops/clinic/${cell.value}`)}
            className="primary-btn-small"
          >
            View
          </button>
        );
      },
    },
  ];

  const columns = useMemo(() => renderColumns, [loading, data]);
  return (
    <>
      {!loading ? (
        <TableContainer columns={columns} data={data} loading={loading} />
      ) : (
        <PatientLoader />
      )}
    </>
  );
};

export default OverdueInvoicesDataTable;
